var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var Svg24 = function Svg24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 25 25"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M4.5 5.5a1 1 0 0 1 1 1v3l.004.154A3 3 0 0 0 8.5 12.5h9.586l-3.293-3.293-.068-.076a1 1 0 0 1 1.406-1.407l.076.069 5 5 .008.009q.094.096.16.215l.013.022a1 1 0 0 1 .072.181 1 1 0 0 1-.118.817l-.023.032q-.017.026-.036.05a1 1 0 0 1-.06.068l-.016.02-5 5a1 1 0 1 1-1.414-1.414l3.293-3.293H8.5a5 5 0 0 1-4.993-4.743L3.5 9.5v-3a1 1 0 0 1 1-1"
  })));
};
export default Svg24;